export default "__VITE_ASSET__D2N5h$1J__"